import { render, staticRenderFns } from "./EditMail.vue?vue&type=template&id=36b967c7&scoped=true"
import script from "./EditMail.vue?vue&type=script&lang=js"
export * from "./EditMail.vue?vue&type=script&lang=js"
import style0 from "./EditMail.vue?vue&type=style&index=0&id=36b967c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b967c7",
  null
  
)

export default component.exports